import React, { Component } from "react";
import Page from "../../Controls/Page";
import Input from "../../Controls/Input";
import PageSection from "../../Controls/PageSection";

class LoyaltyCredentials extends Component {
  constructor(props) {
    super(props);

    const locationState = this.props.location && this.props.location.state ? this.props.location.state : {};
    const registrationId = locationState && locationState.hasOwnProperty('registrationId') ? locationState.registrationId : "";
    const gateway = locationState && locationState.hasOwnProperty('gateway') ? locationState.gateway : "";
    const credentials = locationState && locationState.hasOwnProperty('credentials') ? locationState.credentials : {};
    const mode = locationState && locationState.hasOwnProperty('mode') ? locationState.mode : "create";

    this.state = {
      registrationId: registrationId,
      gateway: gateway,
      mode: mode,
      saving: false,
      formData: {
        // MLoyal fields
        apiUrl: credentials && credentials.hasOwnProperty('apiUrl') ? credentials.apiUrl : "",
        loginId: credentials && credentials.hasOwnProperty('loginId') ? credentials.loginId : "",
        password: credentials && credentials.hasOwnProperty('password') ? credentials.password : "",
        // EasyRewardz fields
        apiUserName: credentials && credentials.hasOwnProperty('apiUserName') ? credentials.apiUserName : "",
        appId: credentials && credentials.hasOwnProperty('appId') ? credentials.appId : "",
        devId: credentials && credentials.hasOwnProperty('devId') ? credentials.devId : "",
        programCode: credentials && credentials.hasOwnProperty('programCode') ? credentials.programCode : "",
        userName: credentials && credentials.hasOwnProperty('userName') ? credentials.userName : "",
        userPassword: credentials && credentials.hasOwnProperty('userPassword') ? credentials.userPassword : "",
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    this.setState((prevState) => ({
      formData: Object.assign({}, prevState.formData, { [field]: value })
    }));
  }

  handleCancel() {
    window.history.back();
  }

  async handleSubmit() {
    const formData = this.state.formData;
    const gateway = this.state.gateway;
    const registrationId = this.state.registrationId;

    let payloadCredentials = {};

    if (gateway === "MLoyal") {
      if (!formData.apiUrl || !formData.loginId || !formData.password) {
        this.props.getToastr("Please fill all required fields");
        return;
      }
      payloadCredentials = {
        apiUrl: formData.apiUrl,
        loginId: formData.loginId,
        password: formData.password
      };
    } else if (gateway === "EasyRewardz") {
      if (!formData.apiUrl || !formData.apiUserName || !formData.appId || !formData.devId || !formData.programCode || !formData.userName || !formData.userPassword) {
        this.props.getToastr("Please fill all required fields");
        return;
      }
      payloadCredentials = {
        apiUrl: formData.apiUrl,
        apiUserName: formData.apiUserName,
        appId: formData.appId,
        devId: formData.devId,
        programCode: formData.programCode,
        userName: formData.userName,
        userPassword: formData.userPassword
      };
    }

    const payload = {
      registrationId: registrationId,
      gateway: gateway,
      credentials: payloadCredentials
    };

    try {
      this.setState({ saving: true });
      // TODO: Replace with actual API call when available
      console.log("Saving " + gateway + " credentials:", payload);
      this.props.getToastr("Credentials saved successfully (Mock)");
      this.setState({ saving: false });
      window.history.back();
    } catch (error) {
      console.error(error);
      this.props.getToastr("Failed to save credentials");
      this.setState({ saving: false });
    }
  }

  render() {
    const gateway = this.state.gateway;
    const formData = this.state.formData;

    return (
      <Page
        title={(gateway ? gateway : "Loyalty") + " Setup"}
        showSaveButton={true}
        showCancelButton={true}
        processing={this.state.saving}
        onClick={(action) => {
          if (action === "cancel") {
            this.handleCancel();
          } else if (action === "save") {
            this.handleSubmit();
          }
        }}
      >
        <PageSection>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            
            {gateway === "MLoyal" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="API URL"
                  placeholder="Enter API URL"
                  value={formData.apiUrl}
                  onChange={(value) => this.handleChange("apiUrl", value)}
                  required={true}
                />
                <Input
                  type="text"
                  label="Login ID"
                  placeholder="Enter Login ID"
                  value={formData.loginId}
                  onChange={(value) => this.handleChange("loginId", value)}
                  required={true}
                />
                <Input
                  type="password"
                  label="Password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={(value) => this.handleChange("password", value)}
                  required={true}
                />
              </React.Fragment>
            )}

            {gateway === "EasyRewardz" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="API URL"
                  placeholder="Enter API URL"
                  value={formData.apiUrl}
                  onChange={(value) => this.handleChange("apiUrl", value)}
                  required={true}
                />
                
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "16px"
                }}>
                  <Input
                    type="text"
                    label="API User Name"
                    placeholder="API User Name"
                    value={formData.apiUserName}
                    onChange={(value) => this.handleChange("apiUserName", value)}
                    required={true}
                  />
                  <Input
                    type="text"
                    label="App ID"
                    placeholder="App ID"
                    value={formData.appId}
                    onChange={(value) => this.handleChange("appId", value)}
                    required={true}
                  />
                </div>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "16px"
                }}>
                  <Input
                    type="text"
                    label="Dev ID"
                    placeholder="Dev ID"
                    value={formData.devId}
                    onChange={(value) => this.handleChange("devId", value)}
                    required={true}
                  />
                  <Input
                    type="text"
                    label="Program Code"
                    placeholder="Program Code"
                    value={formData.programCode}
                    onChange={(value) => this.handleChange("programCode", value)}
                    required={true}
                  />
                </div>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "16px"
                }}>
                  <Input
                    type="text"
                    label="User Name"
                    placeholder="User Name"
                    value={formData.userName}
                    onChange={(value) => this.handleChange("userName", value)}
                    required={true}
                  />
                  <Input
                    type="password"
                    label="User Password"
                    placeholder="User Password"
                    value={formData.userPassword}
                    onChange={(value) => this.handleChange("userPassword", value)}
                    required={true}
                  />
                </div>
              </React.Fragment>
            )}

          </div>
        </PageSection>
      </Page>
    );
  }
}

export default LoyaltyCredentials;